<template>
  <div class="page-main">
    <page-title />
    <page-card>
      <template slot="header">
        <div class="spaceBetween">
          <span>Producer Annual Review List</span>
          <div>
            <el-input
              v-model="searchData.companyName"
              class="search-input"
              placeholder="Enter company name to search…"
              @keyup.enter="getList"
            >
              <el-button slot="append" size="mini" @click="getList">
                <svg-icon icon-class="tn-search" />
              </el-button>
            </el-input>
          </div>
        </div>
      </template>
      <div slot="body" class="page-table" style="margin-top: -12px">
        <el-table
          v-loading="loading"
          stripe
          :data="tableList"
          highlight-current-row
        >
          <el-table-column prop="companyName" label="Company Name" />
          <el-table-column
            prop="account"
            label="treasurenet Account"
            show-overflow-tooltip
          />
          <el-table-column
            prop="registrationDate"
            label=" Identity Expiration date"
            width="240px"
          >
            <template slot-scope="{ row }">
              {{ getWellTime(row,true) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="registrationDate"
            label="Submission Date"
            width="220px"
          >
            <template slot-scope="{ row }">

              <span v-if="checkBtn(row,2)">--</span>
              <span v-else>{{ getWellTime(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Operation" label="Operation" width="200px">
            <template slot-scope="{ row }">
              <el-button v-if="checkBtn(row,5)" type="text" @click="toApprove(row)">Examine</el-button>
              <el-button v-if="checkBtn(row,2)" type="text" @click="toApprove(row,'reject')">Reject</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-bottom-btn">
          <pagination
            :total="queryParams.total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.eachpage"
            @pagination="getList()"
          />
        </div>
      </div>
    </page-card>
  </div>
</template>

<script>
import { annualReviewList } from '@/api/manager.js'
export default {
  components: {},
  data() {
    return {
      loading: false,
      searchData: {
        companyName: undefined
      },
      tableList: [],
      queryParams: {
        total: 0,
        page: 1,
        eachpage: 10
      }
    }
  },
  computed: {},
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const param = {
        page: this.queryParams.page,
        limit: this.queryParams.eachpage,
        companyName: this.searchData.companyName
      }
      this.loading = true
      annualReviewList(param)
        .then(res => {
          this.loading = false
          this.tableList = res.result.list
          this.queryParams.total = res.result.total
        })
        .catch(() => {
          this.loading = false
        })
    },
    getWellTime(row, flag = false) {
      if (row.data.well) {
        if (flag) {
          return this.moment(new Date(row.data.well.timestamp)).add(1, 'years').format('yyyy-MM-DD')
        } else {
          return this.moment(new Date(row.data.well.timestamp)).format('yyyy-MM-DD')
        }
      } else if (row.data.timestamp) {
        if (flag) {
          return this.moment(new Date(row.data.timestamp)).add(1, 'years').format('yyyy-MM-DD')
        } else {
          return this.moment(new Date(row.data.timestamp)).format('yyyy-MM-DD')
        }
      }
    },
    toApprove(row, type) {
      this.$router.push({
        path: '/annualReview/approve/detail',
        query: {
          userID: row.userID,
          wellID: row.data.well ? row.data.well.wellID : row.data.wellID,
          type: type
        }
      })
    },
    checkBtn(row, val) {
      const data = row.data.well || row.data
      const status = data && data.status
      return status === val
    }
  }
}
</script>
<style scoped lang="scss">

</style>
